import { useLocation, useNavigate } from 'react-router-dom';
import query from 'qs';
import { useEffect, useMemo } from 'react';

type Filters = { [key: string]: string | null };
type SetFilter<T extends Filters, K extends keyof T> = (key: keyof T, value: T[K]) => void;
type ReturnType<T extends Filters> = [T, SetFilter<T, keyof T>];

export function useFilters<T extends Filters>(initialValue: T): ReturnType<T> {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const q = query.stringify(initialValue, {
			addQueryPrefix: true,
			skipNulls: true,
		});

		navigate(q);
	}, []);

	const filters = useMemo(() => {
		const parsed = query.parse(location.search, {
			ignoreQueryPrefix: true,
		});

		return parsed as any as T;
	}, [location.search]);

	const setFilter: SetFilter<T, keyof T> = (key, value) => {
		const q = query.stringify(
			{
				...filters,
				[key]: value,
			},
			{
				addQueryPrefix: true,
				skipNulls: true,
			}
		);

		navigate(q);
	};

	return [filters, setFilter];
}
